// PDF tickets and receipts in the browser with pdfme (MIT, github.com/pdfme/pdfme) — loaded only when someone downloads.
const PINK = "#E0007A";

export async function makePdf({ title, subtitle, rows = [], code, qr, note, filename = "fable.pdf" }) {
  const [{ generate }, { BLANK_PDF }, schemas] = await Promise.all([import("@pdfme/generator"), import("@pdfme/common"), import("@pdfme/schemas")]);
  const fields = [];
  const inputs = {};
  const add = (name, value, y, h, size, extra = {}) => { fields.push({ name, type: "text", position: { x: 20, y }, width: 170, height: h, fontSize: size, ...extra }); inputs[name] = String(value ?? ""); };
  add("brand", "Fable+", 16, 10, 20, { fontColor: PINK });
  add("title", title, 32, 12, 18);
  if (subtitle) add("subtitle", subtitle, 45, 8, 11, { fontColor: "#555555" });
  let y = 60;
  rows.forEach(([k, v], i) => { add("k" + i, k, y, 6, 9, { fontColor: "#777777" }); add("v" + i, v, y + 5, 8, 12); y += 16; });
  if (code) { add("codeLabel", "Reference", y + 2, 6, 9, { fontColor: "#777777" }); add("code", code, y + 8, 14, 26, { characterSpacing: 2 }); y += 26; }
  if (qr) { fields.push({ name: "qr", type: "qrcode", position: { x: 20, y: y + 2 }, width: 40, height: 40 }); inputs.qr = String(qr); y += 46; }
  if (note) add("note", note, Math.min(y + 4, 260), 20, 9, { fontColor: "#555555" });
  add("foot", "fableplus.uk · Keep this for your records", 278, 6, 8, { fontColor: "#999999" });
  const pdf = await generate({ template: { basePdf: BLANK_PDF, schemas: [fields] }, inputs: [inputs], plugins: { text: schemas.text, qrcode: schemas.barcodes.qrcode } });
  const url = URL.createObjectURL(new Blob([pdf.buffer], { type: "application/pdf" }));
  const a = document.createElement("a"); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

const dt = (s) => (s ? new Date(s).toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
const gbp = (v) => (v == null ? "" : "£" + Number(v).toFixed(2));

export const ticketPdf = (t) => makePdf({
  title: (t.event && t.event.title) || "Ticket", subtitle: t.tier_name || t.ticket_type || "Admission",
  rows: [["When", dt(t.event && t.event.starts_at)], ["Where", [t.event && t.event.venue_name, t.event && t.event.address].filter(Boolean).join(", ") || "Online"], ["Holder", t.holder_name || "Ticket holder"]],
  code: t.code, note: "Show the live QR in your Fable+ tickets at the door when you can — this backup code also works.", filename: "ticket-" + (t.code || t.id) + ".pdf",
});

export const receiptPdf = (b) => makePdf({
  title: "Booking receipt", subtitle: b.listing_title,
  rows: [["Provider", b.provider_name || ""], ["Date", [b.date, b.time_slot].filter(Boolean).join(" · ")], ["Status", b.status || ""], ["Paid", gbp(b.total ?? b.subtotal)], ["Booked on", dt(b.created_at)]],
  code: (b.id || "").slice(0, 8).toUpperCase(), filename: "receipt-" + (b.id || "booking").slice(0, 8) + ".pdf",
  note: "Prices include any fees shown at checkout. Questions? Message the provider from your bookings.",
});
